import { Breadcrumb, Col, Input, Popconfirm, Row, Space, Table, Tooltip } from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import { ReactComponent as ArchiveRestore } from "../../../image/ArchiveRestore.svg";
import SearchIcon from "../../../image/SearchIcon.svg";
import "../../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";

const { Search } = Input;

const ArchiveSectorList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [reload, setReload] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [archiveSectorList, setArchiveSectorList] = useState([]);
  const [searchText, setSearchText] = useState("");

  // State initiailisation
  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  // feact the Archive Sector List
  useEffect(() => {
    const getArchiveSectorList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("sectorname-archive/", state);
        if (apiResponse.status) {
          setArchiveSectorList(apiResponse.data.results);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archive_sector_name"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getArchiveSectorList();
  }, [state, reload, t]);

  // Function to handle Change
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  // Get the sorting enum value based on the sort field and order
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";

    if (sortField === "zone_name" && sortOrder === "ascend") {
      sortingEnumKey = "zone_name";
    }
    if (sortField === "zone_name" && sortOrder === "descend") {
      sortingEnumKey = "-zone_name";
    }

    return sortingEnumKey;
  };

  // Function to Call Back Delayed
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
          (key) => !changeRows.find((row) => row.id === key)
        );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  // function  to restore the data
  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("sectorname-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("sector_restore_successfully2"));
        setReload(!reload);
        setSelectedRow([]);
        navigate("/sector");
      } else {
        ErrorNotificationMsg(t("error_in_restore_sector"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const columns = [
    {
      title: "Sector Name",
      dataIndex: "sector_name",
      key: "sector_name",
      sorter: true,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: "100px",
      render: (text, record) => (
        <Space>
          <Tooltip
            color={colors}
            placement="right"
            title={
              <span style={{ color: "#fff" }}>
                Restore
              </span>
            }
          >
            <Popconfirm
              className="action"
              title={t("pop_restore_title")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleRestore(record.id)}
            >
              <ArchiveRestore className="ArchiverestorImg" />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];
  const colors = ["#094E8F"];
  return (
  <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">

            <h3>{t("archived_sector_list")}</h3>


            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/sector">{t("sector")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("archiveList")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
              <Search
  value={searchText}
  onChange={(e) => {
    const value = e.target.value;
    setSearchText(value);
    debounceLoadData(value, onSearch);
  }}
  allowClear
  onSearch={(value) => {
    setSearchText(value);
    onSearch(value);
  }}
  prefix={
    <img
      src={SearchIcon}
      alt="SearchIcon"
      className="SearchIcon"
      width={22}
    />
  }
  placeholder={t("pl_search_list")}
  style={{ width: 250 }}
/>
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_restore")}
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>

      <div className="stepscontentwrap">
        <div className="stepsContent">
      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body" style={{padding:'0'}}>
          <Row className="tblheader">
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              className="tbl-heading"
            ></Col>
          </Row>
<div className="tablewrp">
          <Table
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={archiveSectorList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          </div>
          <div className="FormFooter Container">
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("pl_back_to_list")}
              onClick={() => navigate(`/sector`)}
            />
          </div>
        </div>
      </section>
    </div> </div>
    </>
  );
};

export default ArchiveSectorList;
